import React, { useState } from "react";
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from "@/components/ui/form";
import { Upload } from "lucide-react";

interface LogoUploadProps {
  form: any;
}

export const LogoUpload = ({ form }: LogoUploadProps) => {
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    // Update form value
    form.setValue("logo", file);

    // Create preview
    const reader = new FileReader();
    reader.onload = () => {
      setPreviewUrl(reader.result as string);
    };
    reader.readAsDataURL(file);
  };

  return (
    <FormField
      control={form.control}
      name="logo"
      render={({ field: { value, onChange, ...fieldProps } }) => (
        <FormItem>
          <FormLabel>Logo</FormLabel>
          <FormControl>
            <div className="flex flex-col items-center">
              <div
                className="w-32 h-32 border-2 border-dashed rounded-lg flex flex-col items-center justify-center bg-gray-50 cursor-pointer hover:bg-gray-100 transition-colors"
                onClick={() => document.getElementById("logo-upload")?.click()}
              >
                {previewUrl ? (
                  <img
                    src={previewUrl}
                    alt="Logo preview"
                    className="w-28 h-28 object-contain"
                  />
                ) : (
                  <>
                    <Upload className="h-10 w-10 mb-2 text-gray-400" />
                    <span className="text-sm text-gray-500">Upload logo</span>
                  </>
                )}
              </div>
              <input
                id="logo-upload"
                type="file"
                className="hidden"
                accept="image/*"
                onChange={handleFileChange}
                {...fieldProps}
              />
              <span className="text-xs text-gray-500 mt-2">
                Recommended: 400x400px, PNG or JPG
              </span>
            </div>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
